/* Движение (APP-SPEC §1.3–1.4): то же, что SteosUI.pop/swap/tick и BotCore.shake/flip, без зависимости от прототипа.
   Классы и ключевые кадры — общего набора (steos-ui.css: .enter → vin 220 мс, .leave → vout 160 мс, .tick) и ядра (bot-core.css: .bc-shake).
   Двигается только opacity и transform; дрожь — свойство translate (§1.3.4), чтобы не сбивать свой transform элемента. */

/** Пауза swap до перестройки, мс: уход .leave идёт 160 мс */
export const SWAP_MS = 170;
/** Сдвиг блоков формы при смене раскладки (flip), мс и кривая */
export const FLIP_MS = 220;
export const EASE = 'cubic-bezier(.2,.8,.2,1)';

/** [ТЕСТ] заморозка для снимков: html.still (флаг хэша .still) */
export const isStill = () => document.documentElement.classList.contains('still');
/** Без анимаций: системное «уменьшить движение» или заморозка */
export const reduced = () => isStill() || typeof matchMedia !== 'function' || matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Появление блока один раз: класс .enter перезапускается, снимается по окончании */
export function pop(el: Element | null | undefined): void {
  if (!el) return;
  el.classList.remove('enter');
  void (el as HTMLElement).offsetWidth;
  el.classList.add('enter');
  el.addEventListener('animationend', () => el.classList.remove('enter'), { once: true });
}

/** Смена содержимого: блоки уходят (.leave), через SWAP_MS build() перестраивает, новые (или те же) блоки входят через pop */
export function swap(els: Element | Element[], build: () => Element[] | void): void {
  const L = ([] as Element[]).concat(els).filter(Boolean);
  L.forEach(el => {
    el.classList.remove('enter');
    el.classList.add('leave');
  });
  setTimeout(() => {
    L.forEach(el => el.classList.remove('leave'));
    const out = build();
    (out && out.length ? out : L).forEach(pop);
  }, SWAP_MS);
}

/** Позднее содержимое (картинка или блок витрины, пришедшие после первого кадра показа) проявляется так же,
    как входит блок эталона (pop: vin 220 мс), но только opacity — место под ним уже стоит, сдвигать нечего.
    У эталона позднего содержимого нет: все картинки — blob в памяти. В заморозке и при «уменьшить движение» — сразу */
export function fadeIn(el: Element | null | undefined): void {
  if (!el || reduced() || typeof (el as HTMLElement).animate !== 'function') return;
  (el as HTMLElement).animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: EASE });
}

/** Мелкое обновление числа на месте */
export function tick(el: Element | null | undefined): void {
  if (!el) return;
  el.classList.remove('tick');
  void (el as HTMLElement).offsetWidth;
  el.classList.add('tick');
}

/** Отклик «нельзя»: дрожь ±3 px три раза за 360 мс (класс bc-shake); в заморозке и при «уменьшить движение» — без дрожи */
export function shake(el: HTMLElement | null | undefined): void {
  if (!el || reduced()) return;
  el.classList.remove('bc-shake');
  void el.offsetWidth;
  el.classList.add('bc-shake');
  const t = (el as HTMLElement & { _bcShT?: number })._bcShT;
  clearTimeout(t);
  (el as HTMLElement & { _bcShT?: number })._bcShT = window.setTimeout(() => el.classList.remove('bc-shake'), 420);
}

/** Сдвиг блоков при смене раскладки: блоки, оставшиеся на экране, едут со старого места на новое только transform (APP-SPEC §1.3.2) */
export function flip(els: HTMLElement[], mutate: () => void): void {
  const before = new Map(els.map(el => [el, el.getBoundingClientRect()]));
  mutate();
  if (reduced()) return;
  for (const [el, r] of before) {
    if (!el.isConnected) continue;
    const n = el.getBoundingClientRect();
    const dx = r.left - n.left;
    const dy = r.top - n.top;
    if (!dx && !dy) continue;
    el.animate([{ transform: `translate(${dx}px,${dy}px)` }, { transform: 'none' }], { duration: FLIP_MS, easing: EASE });
  }
}
